import { render, staticRenderFns } from "./imported_creditors.vue?vue&type=template&id=a13bf19e&"
import script from "./imported_creditors.vue?vue&type=script&lang=js&"
export * from "./imported_creditors.vue?vue&type=script&lang=js&"
import style0 from "./imported_creditors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports